import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'boldPredictiveText',
    standalone: false
})
export class BoldPredictiveTextPipe implements PipeTransform {
    transform(textValue: string, subTextValue: string): string {
        let newString = "";
        let isFirstMatch = true;
        const splitText = textValue.split(new RegExp(`(${subTextValue})`, 'i'));
        for (let i = 0; i < splitText.length; i++) {
            if (splitText[i].toLowerCase() === subTextValue.toLowerCase() && isFirstMatch === true) {
                newString = newString + splitText[i];
                isFirstMatch = false;
            } else {
                newString = newString + `<b>${splitText[i]}</b>`;
            }
            if(splitText[i].includes(" ")) {
                isFirstMatch = true;
            }
        }
        return newString;
    }
}
